import { useMemo } from "react"

import { Trans, useI18next } from "gatsby-plugin-react-i18next"
import styled,{css} from "styled-components"
import { fmobile, fresponsive, ftablet } from "utils/fullyResponsive"
import InnerWrapper from "components/InnerWrapper"
import Callout from "components/TextElements/Callout"
import ToolTip from "components/ToolTip"
import colors from "styles/colors"
import media from "styles/media"
import text, { transparentText } from "styles/text"
import UniversalLink from "utils/Loader/UniversalLink"
import useMedia from "utils/useMedia"
import CoastDemoWidget from "sections/cards/CoastDemoWidget"

export default function ExpenseManagement() {
  const titleWidth = useMedia("100%", "100%", "63.77vw", "90vw")
  const textWidth = useMedia("566px", "34.096vw", "59.863vw", "90vw")
  const titleSize = useMedia(text.h4, text.h4, text.h3, text.h1Mobile)
  const textSize = useMedia(text.bodyR, text.bodyR, text.bodyL, text.bodyR)
  const { t } = useI18next()


  return (
    <Wrapper>
      <InnerWrapper setWidth={useMedia("1440px", "100%", "100%", "100%")} flex>
         <InnerInnerWrapper>
          <CalloutWrapper>
            <Callout
              variant="lightmode"
              kicker={{
                text: t("B2B Expense Management") ?? "",
                gradient: colors.seaFoam500,
                icon: "layersAltSeafoam",
              }}
              title={{
                content: t(
                  "Your business clients need greater, flexible control over their revenues."
                ),
                size: titleSize,
                width: titleWidth,
                color: colors.blue800,
              }}
              text={{
                width: textWidth,
                content: t(
                  `Sustainable growth starts by maximizing expense and spend control. By helping your business clients simplify payments and expense management capabilities, you can help them drive profitable growth and deliver differentiated features that build value across the B2B spend cycle.`)+t(`Galileo enables scalable payments partnerships by giving fintechs and payments companies the technology to offer expense and spend controls that enable customers to instantly fund and manage spend. This includes capabilities like real-time funding, account-level controls, corporate charge accounts, lending, and corporate hierarchy support.`
                ),
                color: colors.blue200,
                size: textSize,
              }}
              buttons={[
                {
                  text: t("Explore More") ?? "Explore More",
                  arrow: true,
                  type: "secondary",
                  route:
                    "https://docs.galileo-ft.com/pro/docs/business-banking-programs",
                },
              ]}
            />
          </CalloutWrapper>
          <VideoWrapper>
          <CoastDemoWidget demoWidgetURL="https://galileo.coastdemo.com/embed/6527e9aa911411e857a870ef" />
          </VideoWrapper>
         </InnerInnerWrapper>
      </InnerWrapper>
    </Wrapper>
  )
}

const InnerInnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  gap: 50px;

  ${fresponsive(css`
    padding: 60px 129px;
  `)}

  ${media.tablet} {
    flex-direction: column;
    align-items: center;
  }

  ${fmobile(css`
    padding: 80px 20px;
    flex-direction: column;
    align-items: center;
  `)}
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 9.036vw 0;
  overflow-x: hidden;

  ${media.fullWidth} {
    padding: 150px 0;
  }
  ${media.tablet} {
    padding: 14.648vw 0;
  }
  ${media.mobile} {
    padding: 21.333vw 0;
  }
`



const CalloutWrapper = styled.div`
  width: 38.855vw;
  margin-top: 0px;
  ${media.fullWidth} {
    width: 645px;
    margin-top: 0px;
  }
  ${media.tablet} {
    width: fit-content;
    margin-top: 0px;
  }
  ${media.mobile} {
    width: fit-content;
    margin-top: 0px;
  }
`
const VideoWrapper = styled.div<{ isVideo?: boolean }>`
  width: 38.855vw;
  margin-top: 5vw;
  ${media.fullWidth} {
    width: 645px;
    margin-top: 0px;
  }
  ${media.tablet} {
    width: fit-content;
    margin-top: 0px;
  }
  ${media.mobile} {
    width: 335px;
    height: 428px;
    margin-top: 0px;
  }
`


// const ImageWrapper = styled.div`
//   /* overflow: hidden; */
//   ${media.fullWidth} {
//     width: 646px;
//     height: 550px;
//   }
//   ${media.desktop} {
//     width: 38.916vw;
//     height: 33.133vw;
//   }

//   ${media.tablet} {
//     width: 81.445vw;
//     height: auto;
//   }

//   ${media.mobile} {
//     width: 89.333vw;
//     height: 58.933vw;
//   }
// `
const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;

  ${fresponsive(css`
    width: 626px;
    height: 800px;
  `)}

  ${fmobile(css`
    width: 335px;
    height: 428px;
  `)}
`